import { Component, EventEmitter, Output } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import {
  ListPendingInvitationsParams,
  SellerInvitation,
  SellerInvitationsService,
} from 'src/app/core/seller-invitations.service';

@Component({
  selector: 'app-pending-invitations-data',
  templateUrl: './pending-invitations-data.component.html',
  styleUrls: ['./pending-invitations-data.component.scss'],
})
export class PendingInvitationsDataComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  invitations?: SellerInvitation[];
  cursor: string | null = null;
  filters?: ListPendingInvitationsParams;

  constructor(private seller_service: SellerInvitationsService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.invitations = [];
    this.cursor = null;
    this.filters = undefined;
    this.listPendingInvitations();
  }

  onRefresh(): void {
    this.invitations = [];
    this.cursor = null;
    this.filters = undefined;
    this.listPendingInvitations();
  }

  onFilter(filters?: ListPendingInvitationsParams): void {
    this.invitations = [];
    this.cursor = null;
    this.filters = filters;
    this.listPendingInvitations(filters);
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listPendingInvitations(this.filters, true);
  }

  listPendingInvitations(filters?: ListPendingInvitationsParams, is_load_more_running?: boolean): void {
    console.log('listPendingInvitations', filters, is_load_more_running);
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_steps_params = {
      ...filters,
      cursor: this.cursor,
    };

    this.seller_service.listPendingInvitations(list_steps_params).subscribe({
      next: response => {
        const invitations = response.data.data;
        this.invitations = (this.invitations ? this.invitations : []).concat(invitations);
        this.cursor = response.data.cursor;

        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.error_service.processApiError(processed_error.code, processed_error.message);
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
